'use client'

import Link from 'next/link'
import type { Footer as FooterType, Header as HeaderType } from '@/payload-types'

import { Logo } from '@/components/payload/Logo/Logo'
import { Hamburger } from '../Hamburger.client'
import { FlatTitle } from '@/components/frontend/FlatTitle'

interface Props {
    title: string
    header: HeaderType
    footer: FooterType
}

export function ThinHeader({ header, footer, title }: Props) {
    return (
        <div className='py-2 flex gap-2 justify-between items-center'>
            <Link href='/'>
                <Logo className='h-4 w-full' loading='eager' priority='high' />
            </Link>
            <div className='hidden truncate text-2xl font-bold md:block'>
                <FlatTitle heading={title} />
            </div>
            <div className='flex items-center'>
                <Hamburger classes={{ triggerIcon: 'w-6 h-6' }} header={header} footer={footer} />
            </div>
        </div>
    )
}
